module.exports = __webpack_public_path__ + "static/media/firming.f404af20.svg";